const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20red%20carpet%20event%20atmosphere%20with%20warm%20golden%20spotlights%2C%20elegant%20award%20show%20vibe%2C%20soft%20bokeh%20background%2C%20glamorous%20entertainment%20industry%20aesthetic%2C%20rich%20coral%20and%20amber%20tones%2C%20cinematic%20lighting&width=600&height=400&seq=carousel-01&orientation=landscape',
    tag: '独家爆料',
    title: '年度最劲爆明星恋情大揭秘',
    summary: '多位知情人士透露，某顶流艺人疑似与圈内知名歌手低调交往超过半年，细节令人震惊。',
    date: '2小时前',
    hot: true,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Television%20production%20set%20with%20cameras%20and%20bright%20studio%20lights%2C%20variety%20show%20recording%20atmosphere%2C%20warm%20stage%20lighting%2C%20professional%20broadcast%20equipment%2C%20entertainment%20industry%20behind%20scenes%2C%20soft%20coral%20accent%20tones&width=600&height=400&seq=carousel-02&orientation=landscape',
    tag: '综艺热点',
    title: '热门综艺录制现场突发状况全记录',
    summary: '某当红综艺节目最新一期录制中突发意外，导演组紧急叫停，现场观众爆料细节曝光。',
    date: '4小时前',
    hot: true,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20premiere%20event%20with%20movie%20posters%20and%20cinema%20atmosphere%2C%20crowds%20gathering%2C%20warm%20evening%20lighting%2C%20entertainment%20news%20coverage%20scene%2C%20professional%20photography%20equipment%2C%20soft%20amber%20and%20cream%20tones&width=600&height=400&seq=carousel-03&orientation=landscape',
    tag: '影视追踪',
    title: '暑期档票房大战：谁才是最大赢家',
    summary: '今年暑期档竞争异常激烈，多部大片同台竞技，票房数据背后暗藏玄机，行业格局或将生变。',
    date: '6小时前',
    hot: false,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Music%20concert%20stage%20with%20colorful%20lighting%20and%20large%20crowd%2C%20live%20performance%20atmosphere%2C%20energetic%20vibe%2C%20warm%20spotlight%20beams%2C%20festival%20feel%2C%20professional%20stage%20production%2C%20soft%20coral%20and%20golden%20color%20palette&width=600&height=400&seq=carousel-04&orientation=landscape',
    tag: '音乐动态',
    title: '天后巡回演唱会门票秒罄创纪录',
    summary: '某天后级歌手新一轮巡回演唱会正式开票，三分钟内全部售罄，创下今年演出市场新纪录。',
    date: '8小时前',
    hot: false,
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20trending%20topic%20visualization%20with%20floating%20headlines%20and%20notification%20elements%2C%20modern%20digital%20news%20aggregation%20concept%2C%20warm%20gradient%20background%2C%20soft%20coral%20and%20amber%20accents%2C%20clean%20interface%20design%20aesthetic&width=600&height=400&seq=carousel-05&orientation=landscape',
    tag: '网红事件',
    title: '顶流网红争议言论引爆全平台讨论',
    summary: '拥有千万粉丝的头部网红因直播中的一番言论引发巨大争议，多个话题同时登上热搜榜。',
    date: '12小时前',
    hot: true,
  },
];

export default function CarouselSection() {
  return (
    <section
      id="carousel"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            焦点大瓜
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            本周最受关注的热点事件
          </p>
        </div>

        {/* Grid: all 5 visible at once */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group flex flex-col rounded-lg bg-background-100 border border-background-200/70 overflow-hidden transition-colors duration-200 hover:border-primary-200"
            >
              {/* Image */}
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-2 left-2 flex gap-1.5">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
                      热门
                    </span>
                  )}
                </div>
              </div>

              {/* Content */}
              <div className="flex flex-col gap-1.5 p-3 md:p-4 flex-1">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {item.summary}
                </p>
                <span className="text-xs text-foreground-500 mt-1">{item.date}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}